// File: assets/hcp-caffeine-calculator.js
(function () {
  function initCalculator(root) {
    if (!root || root.dataset.caffeineCalcInitialized === "true") return;
    root.dataset.caffeineCalcInitialized = "true";

    const content = root.querySelector("[data-calc-content]");
    const results = root.querySelector("[data-calc-results]");
    const inputs = root.querySelectorAll('input[type="number"][data-caffeine]');
    const totalDisplay = root.querySelector("[data-calc-total]");
    const messageDisplay = root.querySelector("[data-calc-message]");
    const decafLinkDisplay = root.querySelector("[data-calc-decaf]");

    function scrollToTopOfCalculator() {
      const wrapper = root.querySelector(".lp-caffeine-calc__wrapper");
      if (!wrapper) return;

      wrapper.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    }

    function calculateTotal() {
      let total = 0;

      inputs.forEach((input) => {
        const qty = parseInt(input.value, 10) || 0;
        const caffeine = parseInt(input.dataset.caffeine, 10) || 0;
        total += qty * caffeine;
      });

      totalDisplay.textContent = `${
        total > 200 ? "🔴" : "🟢"
      } Your Total Daily Caffeine Is ${total}mg`;

      let msg = "";
      if (total < 200) {
        msg = ` 
      <p class="caffeine-calculator_p">
        Great news — you’re within the recommended caffeine limit!
      </p>
      <p class="caffeine-calculator_p">
         The NHS advises keeping caffeine intake below <strong>200mg</strong> a day during pregnancy and while breastfeeding. Staying under this amount helps support you and your baby’s health and wellbeing.
      </p>
      <p>
        To keep your intake low, try swapping fizzy drinks for fruit juice, herbal teas, or decaf tea and coffee. And don’t forget to watch out for hidden sources of caffeine in fizzy drinks and chocolate.
      </p>
    `;
      } else {
        msg = `
      <p class="caffeine-calculator_p">
        You’re currently consuming more than the recommended <strong>200mg</strong> of caffeine per day.
      </p>
      <p class="caffeine-calculator_p">
        During pregnancy and breastfeeding, the NHS advice is to keep caffeine intake below <strong>200mg</strong> daily - and treat it as a maximum limit, not a target
      </p>
      <p class="caffeine-calculator_p">
        <a
          href="https://www.hotteamama.com/collections/decaf-coffee-collection"
          class="caffeine-calculator_link"
        >
          Try switching from caffeinated drinks to fruit juice, herbal tea, or decaf tea and coffee to help reduce your intake
        </a>
      </p>
      <p>Remember, caffeine can be hidden in fizzy drinks, chocolate, and some cold or energy drinks, so always check the label</p>
    `;
      }

      // optional: you can inject a link here 
      messageDisplay.innerHTML = msg;

      content.style.display = "none";
      results.hidden = false;

      // Scroll back to top of calculator to show results
      scrollToTopOfCalculator();
    }

    function resetCalculator() {
      inputs.forEach((input) => (input.value = 0));
      results.hidden = true;
      content.style.display = "";
      totalDisplay.textContent = "";
      messageDisplay.textContent = "";
      decafLinkDisplay.textContent = "";
    }

    // Handle plus/minus with event delegation (works even when clicking the <img>)
    root.addEventListener("click", (e) => {
      const qtyBtn = e.target.closest("[data-qty-btn]");
      if (qtyBtn) {
        const action = qtyBtn.getAttribute("data-qty-btn");
        const qtyWrap = qtyBtn.closest(".lp-caffeine-calc__qty");
        const input = qtyWrap
          ? qtyWrap.querySelector('input[type="number"]')
          : null;
        if (!input) return;

        let value = parseInt(input.value, 10) || 0;

        if (action === "plus") value += 1;
        if (action === "minus") value = Math.max(0, value - 1);

        input.value = value;
        return;
      }

      const actionBtn = e.target.closest("[data-calc-action]");
      if (!actionBtn) return;

      const action = actionBtn.getAttribute("data-calc-action");
      if (action === "calculate") calculateTotal();
      if (action === "reset") resetCalculator();
    });
  }

  function initAll() {
    document.querySelectorAll("[data-caffeine-calc]").forEach(initCalculator);
  }

  // Initial load
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  // Shopify theme editor (so it re-inits when you add/refresh the section)
  document.addEventListener("shopify:section:load", function (event) {
    if (!event || !event.target) return;
    const root = event.target.querySelector("[data-caffeine-calc]");
    if (root) initCalculator(root);
  });
})();